export default {
  INIT_PAGE: 'INIT_PAGE',
  FETCH_MARKDOWN: 'FETCH_MARKDOWN',
  SET_MARKDOWN: 'SET_MARKDOWN',
  UPLOAD_IMAGE: 'UPLOAD_IMAGE',
  WRITE_MARKDOWN: 'WRITE_MARKDOWN',
  SET_PAGE_CONTEXT: 'SET_PAGE_CONTEXT',
  FETCH_CONVERTED_HTML: 'FETCH_CONVERTED_HTML',
  SET_CONVERTED_HTML: 'SET_CONVERTED_HTML',
  WRITE_SCREEN_METADATA: 'WRITE_SCREEN_METADATA',
  REMOVE_SCREEN_METADATA: 'REMOVE_SCREEN_METADATA',
  CREATE_NEW_FILE: 'CREATE_NEW_FILE',
  VALIDATE_UPLOAD_PATH: 'VALIDATE_UPLOAD_PATH',
  FETCH_SERIAL_FILE_NAME: 'FETCH_SERIAL_FILE_NAME',
}
